import React from "react"
import { Link } from "react-router-dom"
import LogoImg from '../assets/images/logo-header.png'

export default function LogoStatic({ maxWidth = '100%', noLink = false }: { maxWidth?: string, noLink?: boolean }) {

  return (
    <Link to={noLink ? '#' : '/'}><img src={LogoImg} alt="Logo" style={{ maxWidth: maxWidth }} /></Link>
  )
}